import { AnyConstructor } from "../types";

export interface IOriginalPrototype {
    constructor: any;
}
export interface IStoreOriginalPrototype {
    originalPrototype: IOriginalPrototype;
}

export class IStoreOriginalPrototype {
    private static _properties: (keyof IStoreOriginalPrototype)[] = ["originalPrototype"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}

/**
 * Uloží prototyp obalované komponenty.
 *
 * @param Base Obalovaná komponenta.
 * @template T obalovaná komponenta
 * @template U typ komponenty, která slouží k porovnávání. Pokud je komponenta obalena vícero mixiny.
 * U by mělo udávat původní obalovanou komponentu, tak jak by byl její typ bez obalení mixiny.
 */
export const StoreOriginalPrototypeMixin = <
    T extends AnyConstructor<any>,
    U extends AnyConstructor<any>>
    (Base: T, ImplementationType: U) => class ChangePrototypeMixin extends Base implements IStoreOriginalPrototype {
        public originalPrototype: IOriginalPrototype;
        constructor(...args: any[]) {
            super(...args);
            this.originalPrototype = ImplementationType.prototype;
        }
    };
